<template>
  <div>
    <b-button-group size="md" v-if="isDisabled">
      <b-button size="sm" class="mb-2" variant="success" @click="uploadImage">
        {{ $l('btn_uploadMultipleImages') || '上传多图' }}
      </b-button>
    </b-button-group>
    <el-row v-if="tableData">
      <viewer :images="tableData">
        <div v-for="(item, index) in tableData" :index="index" :key="index">
          <el-col :span="6">
            <el-row>
              <div class="imgbox">
                <img
                  :src="
                    $osscdn(item.resImageCode) || '/image/static/img/nopic.jpg'
                  "
                />
              </div>
            </el-row>
            <el-row type="flex" style="margin-top:5px;margin-bottom:10px;">
              <el-button-group>
                <el-button
                  style="padding:5px;"
                  v-if="isDisabled"
                  size="mini"
                  icon="el-icon-delete"
                  type="danger"
                  @click="del(item)"
                />
              </el-button-group>
            </el-row>
          </el-col>
        </div>
      </viewer>
    </el-row>
    <el-dialog
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      width="600px"
      :show-close="false"
    >
      <div>
        <el-row class="mt-3" :gutter="20">
          <el-col :sm="{ span: 20 }" :md="{ span: 10 }" :lg="{ span: 10 }">
            <div @click="uploadDisabledMethod">
              <el-upload
                ref="upload"
                :disabled="uploadDisabled"
                multiple
                drag
                action="/oss/ossUploadReturnUrlAndFileId"
                :auto-upload="false"
                style="width:100%"
                :on-change="onFileChange"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  支持上传jpg/png/jpeg/gif文件
                </div>
              </el-upload>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">{{
          $l('add_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" @click="save" size="small">{{
          $l('INDEX.product_dialog_btn_confirm') || '确定'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    resCode: {
      default: ''
    }
  },
  data() {
    return {
      isDisabled: false,
      imageTypeList: ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'],
      infoImagesList: [],
      uploadDisabled: true,
      total: 0,
      resCodeTemp: '',
      params: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      },
      tableData: [],
      formOption: {
        title: this.$l('tips_upload_image') || '上传图片',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true
      }
    }
  },
  methods: {
    ...mapActions('admin/upload', ['push']),
    init(type, val) {
      if (type === 'edit') {
        this.isDisabled = true
      } else if (type === 'detail') {
        this.isDisabled = false
      } else {
        this.isDisabled = false
      }
      this.tableData = []
      this.resCodeTemp = val
      this.loadData()
    },
    loadData() {
      this.$api
        .imageListResearchInfoApi({ resCode: this.resCodeTemp })
        .then((res) => {
          this.params.pageTotal = res.body.count
          this.params.curPage = res.body.curPage
          this.params.pageSize = res.body.pageSize
          this.tableData = res.body.data
        })
    },
    // 分页查询
    handlePaginationChange(val) {
      this.params = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.init(this.resCodeTemp)
    },
    uploadImage() {
      this.formOption.dialogFormVisible = true
    },
    uploadDisabledMethod() {
      if (!this.resCode) {
        this.uploadDisabled = true
        return false
      } else {
        this.uploadDisabled = false
      }
    },
    onFileChange(file, fileList) {
      if (file.status === 'ready') {
        let index = this.imageTypeList.indexOf(file.raw.type)
        if (index < 0) {
          this.$message.warning(
            this.$l('tips_not_support_image') + ':' + file.raw.type ||
              '不支持上传' + file.raw.type + '类型！'
          )
          this.$refs.upload.clearFiles()
          return false
        }
        //原图上传
        this.push({
          file: file.raw,
          added: ({ md5, suffix }) => {
            let code = md5 + '.' + suffix
            this.infoImagesList.push({
              resImageCode: code
            })
          }
        })
      }
    },
    save() {
      if (this.infoImagesList.length < 1) {
        this.$message.info(this.$l('tips_upload_image') || '请上传图片')
        return
      }
      this.$api
        .saveResearchInfoImageApi({
          resCode: this.resCode || this.resCodeTemp,
          infoImagesList: this.infoImagesList
        })
        .then(() => {
          this.$message.success('保存成功')
          this.loadData()
          if (this.$refs.upload) {
            this.$refs.upload.clearFiles()
            this.infoImagesList = []
          }
        })
      this.formOption.dialogFormVisible = false
    },
    cancel() {
      this.infoImagesList = []
      this.formOption.dialogFormVisible = false
    },
    del(val) {
      this.$confirm(this.$l('INDEX.tips_question_delete') || '是否删除？', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确认',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api
            .delResearchInfoImageApi({ resCode: val.resCode, seqno: val.seqno })
            .then(() => {
              this.$message.success(
                this.$l('INDEX.tips_delete_ok') || '删除成功！'
              )
              this.loadData()
            })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.imgbox {
  border: 1px solid #dcdfe6;
  position: relative;
  width: 90px;
  height: 90px;
  border-radius: 4px;
  float: left;
}
.imgbox img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  max-width: 100%;
  max-height: 100%;
}
</style>
